var _style, _desc, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 18",
    style: {
      enableBackground: "new 0 0 20 18"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\t.st0 {\n\t\t\tfill-rule: evenodd;\n\t\t\tclip-rule: evenodd;\n\t\t\tfill: #00242D;\n\t\t}\n\t")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Print") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GLOBAL---COMMUNICATIONS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Communications---Letter-Builder---Letter-Preview",
    transform: "translate(-1219.000000, -56.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dialog",
    transform: "translate(29.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(1138.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button_x2F_Icon",
    transform: "translate(44.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(8.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    transform: "translate(0.833333, 0.416667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    className: "st0",
    d: "M4.4,15.7H14v-5.4H4.4V15.7z M1.6,6c0-0.7,0.6-1.2,1.3-1.2S4.1,5.4,4.1,6S3.6,7.2,2.9,7.2 S1.6,6.7,1.6,6L1.6,6z M6.5,4.8c0.7,0,1.3,0.5,1.3,1.2S7.2,7.2,6.5,7.2S5.3,6.7,5.3,6S5.8,4.8,6.5,4.8L6.5,4.8z M15.9,3.8 H2.4C1.1,3.8,0,4.8,0,6v8.3h2.9v2.8h12.6v-2.8h2.9V6C18.3,4.8,17.3,3.8,15.9,3.8L15.9,3.8z"
  }))))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "GLOBAL---COMMUNICATIONS_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Communications---Letter-Builder---Letter-Preview_1_",
    transform: "translate(-1219.000000, -56.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dialog_1_",
    transform: "translate(29.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3_1_",
    transform: "translate(1138.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button_x2F_Icon_1_",
    transform: "translate(44.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_1_",
    transform: "translate(8.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_1_",
    transform: "translate(0.833333, 0.416667)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    className: "st0",
    points: "3.4,2.2 15.9,2.2 15.9,-0.3 3.4,-0.3  "
  }))))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrint);
export default __webpack_public_path__ + "static/media/icon-print.da4d72e1.svg";
export { ForwardRef as ReactComponent };